export default {
    imgBaseUrl: 'http://wenzhouxiehuih5.zhaohaipan.top:7273/', // 图片前缀
    zhidaoBaseUrl: 'http://wenzhouzhidaoyuanh5.zhaohaipan.top:7273/#',
}